import quote from '../assets/quote.png';
import headerBackground from '../assets/headerBackground.jpg';
import discount from '../assets/discount.jpg';
import discountLogo from '../assets/discountLogo.png';
import expeditionsCard from '../assets/expeditionsCard.jpg';
import runningCard from '../assets/runningCard.jpg';
import hikingCard from '../assets/hikingCard.jpg';
import campingCard from '../assets/campingCard.jpg';
import climbingCard from '../assets/climbingCard.jpg';
import rain from '../assets/rain.jpg';
import boot from '../assets/boot.jpg';
import weather from '../assets/weather.jpg';
import todo from '../assets/todo.jpg';
import night from '../assets/night.jpg';
import trail from '../assets/trail.jpg';
import tent from '../assets/tent.jpg';
import benefits from '../assets/benefits.jpg';
import cube from '../assets/cube.gif';
import newsletter from '../assets/newsletter.jpg';
import hiker from '../assets/hiker.gif';
import delivery from '../assets/delivery.png';
import spring from '../assets/spring.png';
import paypal from '../assets/paypal.png';
import swipe from '../assets/swipe.gif';
import click from '../assets/click.gif';
import maestro from '../assets/maestro.png';
import mastercard from '../assets/mastercard.png';
import visa from '../assets/visa.png';
import americanexpress from '../assets/americanexpress.png';
import checked from '../assets/checked.gif';
import error from '../assets/error.gif';
import exclamation from '../assets/exclamation.png';




/* Adidas */
import adidasBanner from '../assets/adidas/adidasBanner.jpg';
import adidasLogo from '../assets/adidas/adidasLogo.png';

import swiftR2First from '../assets/adidas/swiftR2First.jpg';
import swiftR2Second from '../assets/adidas/swiftR2Second.jpg';
import swiftR2Third from '../assets/adidas/swiftR2Third.jpg';

import freeHikerFirst from '../assets/adidas/freeHikerFirst.jpg';
import freeHikerSecond from '../assets/adidas/freeHikerSecond.jpg';
import freeHikerThird from '../assets/adidas/freeHikerThird.jpg';

import hyperHikerFirst from '../assets/adidas/hyperHikerFirst.jpg';
import hyperHikerSecond from '../assets/adidas/hyperHikerSecond.jpg';
import hyperHikerThird from '../assets/adidas/hyperHikerThird.jpg';

import myShelterFirst from '../assets/adidas/myShelterFirst.jpg';
import myShelterSecond from '../assets/adidas/myShelterSecond.jpg';
import myShelterThird from '../assets/adidas/myShelterThird.jpg';

import liteFlexFirst from '../assets/adidas/liteFlexFirst.jpg';
import liteFlexSecond from '../assets/adidas/liteFlexSecond.jpg';
import liteFlexThird from '../assets/adidas/liteFlexThird.jpg';

import techFirst from '../assets/adidas/techFirst.jpg';
import techSecond from '../assets/adidas/techSecond.jpg';
import techThird from '../assets/adidas/techThird.jpg';

import xploricFirst from '../assets/adidas/xploricFirst.jpg';
import xploricSecond from '../assets/adidas/xploricSecond.jpg';
import xploricThird from '../assets/adidas/xploricThird.jpg';

import liteflexShortsFirst from '../assets/adidas/liteflexShortsFirst.jpg';
import liteflexShortsSecond from '../assets/adidas/liteflexShortsSecond.jpg';
import liteflexShortsThird from '../assets/adidas/liteflexShortsThird.jpg';

import agravicFirst from '../assets/adidas/agravicFirst.jpg';
import agravicSecond from '../assets/adidas/agravicSecond.jpg';
import agravicThird from '../assets/adidas/agravicThird.jpg';

import goretexFirst from '../assets/adidas/goretexFirst.jpg';
import goretexSecond from '../assets/adidas/goretexSecond.jpg';
import goretexThird from '../assets/adidas/goretexThird.jpg';

/* Columbia */
import columbiaBanner from '../assets/columbia/columbiaBanner.jpeg';
import columbiaLogo from '../assets/columbia/columbiaLogo.png';

import firecampFleece3First from '../assets/columbia/firecampFleece3First.jpg';
import firecampFleece3Second from '../assets/columbia/firecampFleece3Second.jpg';
import firecampFleece3Third from '../assets/columbia/firecampFleece3Third.jpg';

import facet60First from '../assets/columbia/facet60First.jpg';
import facet60Second from '../assets/columbia/facet60Second.jpg';
import facet60Third from '../assets/columbia/facet60Third.jpg';

import redmondYouthFirst from '../assets/columbia/redmondYouthFirst.jpg';
import redmondYouthSecond from '../assets/columbia/redmondYouthSecond.jpg';
import redmondYouthThird from '../assets/columbia/redmondYouthThird.jpg';

import adventureFirst from '../assets/columbia/adventureFirst.jpg';
import adventureSecond from '../assets/columbia/adventureSecond.jpg';
import adventureThird from '../assets/columbia/adventureThird.jpg';

import silverRidge4First from '../assets/columbia/silverRidge4First.jpg';
import silverRidge4Second from '../assets/columbia/silverRidge4Second.jpg';
import silverRidge4Third from '../assets/columbia/silverRidge4Third.jpg';

import bloomingportFirst from '../assets/columbia/bloomingportFirst.jpg';
import bloomingportSecond from '../assets/columbia/bloomingportSecond.jpg';
import bloomingportThird from '../assets/columbia/bloomingportThird.jpg';

import maxtrailFirst from '../assets/columbia/maxtrailFirst.jpg';
import maxtrailSecond from '../assets/columbia/maxtrailSecond.jpg';
import maxtrailThird from '../assets/columbia/maxtrailThird.jpg';

import trailSummitRunningFirst from '../assets/columbia/trailSummitRunningFirst.jpg';
import trailSummitRunningSecond from '../assets/columbia/trailSummitRunningSecond.jpg';
import trailSummitRunningThird from '../assets/columbia/trailSummitRunningThird.jpg';

import columbiaUltraFirst from '../assets/columbia/columbiaUltraFirst.jpg';
import columbiaUltraSecond from '../assets/columbia/columbiaUltraSecond.jpg';
import columbiaUltraThird from '../assets/columbia/columbiaUltraThird.jpg';

import fct03First from '../assets/columbia/fct03First.jpg';
import fct03Second from '../assets/columbia/fct03Second.jpg';
import fct03Third from '../assets/columbia/fct03Third.jpg';

/* Diamond */
import diamondBanner from '../assets/diamond/diamondBanner.jpg';
import diamondLogo from '../assets/diamond/diamondLogo.png';

import cliffCabanaFirst from '../assets/diamond/cliffCabanaFirst.jpg';
import cliffCabanaSecond from '../assets/diamond/cliffCabanaSecond.jpg';
import cliffCabanaThird from '../assets/diamond/cliffCabanaThird.jpg';

import missionFirst from '../assets/diamond/missionFirst.jpg';
import missionSecond from '../assets/diamond/missionSecond.jpg';
import missionThird from '../assets/diamond/missionThird.jpg';

import methodFirst from '../assets/diamond/methodFirst.jpg';
import methodSecond from '../assets/diamond/methodSecond.jpg';
import methodThird from '../assets/diamond/methodThird.jpg';

import shadowLVFirst from '../assets/diamond/shadowLVFirst.jpg';
import shadowLVSecond from '../assets/diamond/shadowLVSecond.jpg';
import shadowLVThird from '../assets/diamond/shadowLVThird.jpg';

import captainFirst from '../assets/diamond/captainFirst.jpg';
import captainSecond from '../assets/diamond/captainSecond.jpg';
import captainThird from '../assets/diamond/captainThird.jpg';

import momentumFirst from '../assets/diamond/momentumFirst.jpg';
import momentumSecond from '../assets/diamond/momentumSecond.jpg';
import momentumThird from '../assets/diamond/momentumThird.jpg';

import speedFirst from '../assets/diamond/speedFirst.jpg';
import speedSecond from '../assets/diamond/speedSecond.jpg';
import speedThird from '../assets/diamond/speedThird.jpg';

import venomIceFirst from '../assets/diamond/venomIceFirst.jpg';
import venomIceSecond from '../assets/diamond/venomIceSecond.jpg';
import venomIceThird from '../assets/diamond/venomIceThird.jpg';

import distanceFirst from '../assets/diamond/distanceFirst.jpg';
import distanceSecond from '../assets/diamond/distanceSecond.jpg';
import distanceThird from '../assets/diamond/distanceThird.jpg';

import wizFirst from '../assets/diamond/wizFirst.jpg';

/* Haglofs */
import haglofsBanner from '../assets/haglofs/haglofsBanner.jpg';
import haglofsLogo from '../assets/haglofs/haglofsLogo.png';

import dualityat1First from '../assets/haglofs/dualityat1First.jpg';
import dualityat1Second from '../assets/haglofs/dualityat1Second.jpg';
import dualityat1Third from '../assets/haglofs/dualityat1Third.jpg';

import nordicExpFirst from '../assets/haglofs/nordicExpFirst.jpg';
import nordicExpSecond from '../assets/haglofs/nordicExpSecond.jpg';


import limfhFirst from '../assets/haglofs/limfhFirst.jpg';
import limfhSecond from '../assets/haglofs/limfhSecond.jpg';
import limfhThird from '../assets/haglofs/limfhThird.jpg';

import vassiProFirst from '../assets/haglofs/vassiProFirst.jpg';
import vassiProSecond from '../assets/haglofs/vassiProSecond.jpg';
import vassiProThird from '../assets/haglofs/vassiProThird.jpg';

import limlowFirst from '../assets/haglofs/limlowFirst.jpg';
import limlowSecond from '../assets/haglofs/limlowSecond.jpg';
import limlowThird from '../assets/haglofs/limlowThird.jpg';

import ridgemidFirst from '../assets/haglofs/ridgemidFirst.jpg';
import ridgemidSecond from '../assets/haglofs/ridgemidSecond.jpg';
import ridgemidThird from '../assets/haglofs/ridgemidThird.jpg';

import vina40lFirst from '../assets/haglofs/vina40lFirst.jpg';
import vina40lSecond from '../assets/haglofs/vina40lSecond.jpg';
import vina40lThird from '../assets/haglofs/vina40lThird.jpg';

import midSlimFirst from '../assets/haglofs/midSlimFirst.jpg';
import midSlimSecond from '../assets/haglofs/midSlimSecond.jpg';

import tariusFirst from '../assets/haglofs/tariusFirst.jpg';
import tariusSecond from '../assets/haglofs/tariusSecond.jpg';
import tariusThird from '../assets/haglofs/tariusThird.jpg';

import astralFullFirst from '../assets/haglofs/astralFullFirst.jpg';
import astralFullSecond from '../assets/haglofs/astralFullSecond.jpg';
import astralFullThird from '../assets/haglofs/astralFullThird.jpg';

/* Mammut */
import mammutBanner from '../assets/mammut/mammutBanner.jpg';
import mammutLogo from '../assets/mammut/mammutLogo.png';

import comfortfastFirst from '../assets/mammut/comfortfastFirst.jpg';
import comfortfastSecond from '../assets/mammut/comfortfastSecond.jpg';

import protectDownFirst from '../assets/mammut/protectDownFirst.jpg';
import protectDownSecond from '../assets/mammut/protectDownSecond.jpg';
import protectDownThird from '../assets/mammut/protectDownThird.jpg';

import cragsenderFirst from '../assets/mammut/cragsenderFirst.jpg';
import cragsenderSecond from '../assets/mammut/cragsenderSecond.jpg';
import cragsenderThird from '../assets/mammut/cragsenderThird.jpg';

import rgFirst from '../assets/mammut/rgFirst.jpg';
import rgSecond from '../assets/mammut/rgSecond.jpg';
import rgThird from '../assets/mammut/rgThird.jpg';

import trion75lFirst from '../assets/mammut/trion75lFirst.jpg';
import trion75lSecond from '../assets/mammut/trion75lSecond.jpg';

import nordwand6000First from '../assets/mammut/nordwand6000First.jpg';
import nordwand6000Second from '../assets/mammut/nordwand6000Second.jpg';
import nordwand6000Third from '../assets/mammut/nordwand6000Third.jpg';

import mercuryFirst from '../assets/mammut/mercuryFirst.jpg';
import mercurySecond from '../assets/mammut/mercurySecond.jpg';
import mercuryThird from '../assets/mammut/mercuryThird.jpg';

import nordwandhighFirst from '../assets/mammut/nordwandhighFirst.jpg';
import nordwandhighSecond from '../assets/mammut/nordwandhighSecond.jpg';
import nordwandhighThird from '../assets/mammut/nordwandhighThird.jpg';

import sapuenFirst from '../assets/mammut/sapuenFirst.jpg';
import sapuenSecond from '../assets/mammut/sapuenSecond.jpg';
import sapuenThird from '../assets/mammut/sapuenThird.jpg';

import shortsFirst from '../assets/mammut/shortsFirst.jpg';
import shortsSecond from '../assets/mammut/shortsSecond.jpg';
import shortsThird from '../assets/mammut/shortsThird.jpg';

/* Merrell */
import merrellBanner from '../assets/merrell/merrellBanner.jpg';
import merrellLogo from '../assets/merrell/merrellLogo.png';

import moabspeedFirst from '../assets/merrell/moabspeedFirst.jpg';
import moabspeedSecond from '../assets/merrell/moabspeedSecond.jpg';
import moabspeedThird from '../assets/merrell/moabspeedThird.jpg';

import trailgloveFirst from '../assets/merrell/trailgloveFirst.jpg';
import trailgloveSecond from '../assets/merrell/trailgloveSecond.jpg';
import trailgloveThird from '../assets/merrell/trailgloveThird.jpg';

import altalightFirst from '../assets/merrell/altalightFirst.jpg';
import altalightSecond from '../assets/merrell/altalightSecond.jpg';
import altalightThird from '../assets/merrell/altalightThird.jpg';

import oakcreekFirst from '../assets/merrell/oakcreekFirst.jpg';
import oakcreekSecond from '../assets/merrell/oakcreekSecond.jpg';
import oakcreekThird from '../assets/merrell/oakcreekThird.jpg';

import moabflightFirst from '../assets/merrell/moabflightFirst.jpg';
import moabflightSecond from '../assets/merrell/moabflightSecond.jpg';
import moabflightThird from '../assets/merrell/moabflightThird.jpg';

import nova2midFirst from '../assets/merrell/nova2midFirst.jpg';
import nova2midSecond from '../assets/merrell/nova2midSecond.jpg';
import nova2midThird from '../assets/merrell/nova2midThird.jpg';

import interceptFirst from '../assets/merrell/interceptFirst.jpg';
import interceptSecond from '../assets/merrell/interceptSecond.jpg';
import interceptThird from '../assets/merrell/interceptThird.jpg';

import bravadaFirst from '../assets/merrell/bravadaFirst.jpg';
import bravadaSecond from '../assets/merrell/bravadaSecond.jpg';
import bravadaThird from '../assets/merrell/bravadaThird.jpg';

import rubatoFirst from '../assets/merrell/rubatoFirst.jpg';
import rubatoSecond from '../assets/merrell/rubatoSecond.jpg';
import rubatoThird from '../assets/merrell/rubatoThird.jpg';

import sirentravellerFirst from '../assets/merrell/sirentravellerFirst.jpg';
import sirentravellerSecond from '../assets/merrell/sirentravellerSecond.jpg';
import sirentravellerThird from '../assets/merrell/sirentravellerThird.jpg';

/* North */
import northBanner from '../assets/north/northBanner.jpg';
import northLogo from '../assets/north/northLogo.png';

import ultraEnduranceFirst from '../assets/north/ultraEnduranceFirst.jpg';
import ultraEnduranceSecond from '../assets/north/ultraEnduranceSecond.jpg';
import ultraEnduranceThird from '../assets/north/ultraEnduranceThird.jpg';

import youthChilkFirst from '../assets/north/youthChilkFirst.jpg';
import youthChilkSecond from '../assets/north/youthChilkSecond.jpg';
import youthChilkThird from '../assets/north/youthChilkThird.jpg';

import resolveFirst from '../assets/north/resolveFirst.jpg';
import resolveSecond from '../assets/north/resolveSecond.jpg';
import resolveThird from '../assets/north/resolveThird.jpg';

import grivolaFirst from '../assets/north/grivolaFirst.jpg';
import grivolaSecond from '../assets/north/grivolaSecond.jpg';
import grivolaThird from '../assets/north/grivolaThird.jpg';

import thermoballFirst from '../assets/north/thermoballFirst.jpg';
import thermoballSecond from '../assets/north/thermoballSecond.jpg';
import thermoballThird from '../assets/north/thermoballThird.jpg';

import resolveFullFirst from '../assets/north/resolveFullFirst.jpg';
import resolveFullSecond from '../assets/north/resolveFullSecond.jpg';
import resolveFullThird from '../assets/north/resolveFullThird.jpg';

import motionFirst from '../assets/north/motionFirst.jpg';
import motionSecond from '../assets/north/motionSecond.jpg';
import motionThird from '../assets/north/motionThird.jpg';

import fornetFirst from '../assets/north/fornetFirst.jpg';
import fornetSecond from '../assets/north/fornetSecond.jpg';
import fornetThird from '../assets/north/fornetThird.jpg';

import resolveReflectiveFirst from '../assets/north/resolveReflectiveFirst.jpg';
import resolveReflectiveSecond from '../assets/north/resolveReflectiveSecond.jpg';

import chakalFirst from '../assets/north/chakalFirst.jpg';
import chakalSecond from '../assets/north/chakalSecond.jpg';

/* Osprey */
import ospreyBanner from '../assets/osprey/ospreyBanner.jpg';
import ospreyLogo from '../assets/osprey/ospreyLogo.png';

import zealotchalkFirst from '../assets/osprey/zealotchalkFirst.jpg';
import zealotchalkSecond from '../assets/osprey/zealotchalkSecond.jpg';
import zealotchalkThird from '../assets/osprey/zealotchalkThird.jpg';

import zealot1lFirst from '../assets/osprey/zealot1lFirst.jpg';
import zealot1lSecond from '../assets/osprey/zealot1lSecond.jpg';
import zealot1lThird from '../assets/osprey/zealot1lThird.jpg';

import triplesnapFirst from '../assets/osprey/triplesnapFirst.jpg';

import arielPlusFirst from '../assets/osprey/arielPlusFirst.jpg';
import arielPlusSecond from '../assets/osprey/arielPlusSecond.jpg';
import arielPlusThird from '../assets/osprey/arielPlusThird.jpg';

import archeonFirst from '../assets/osprey/archeonFirst.jpg';
import archeonSecond from '../assets/osprey/archeonSecond.jpg';
import archeonThird from '../assets/osprey/archeonThird.jpg';

import dayliteSlingFirst from '../assets/osprey/dayliteSlingFirst.jpg';
import dayliteSlingSecond from '../assets/osprey/dayliteSlingSecond.jpg';
import dayliteSlingThird from '../assets/osprey/dayliteSlingThird.jpg';

import dayliteToteFirst from '../assets/osprey/dayliteToteFirst.jpg';
import dayliteToteSecond from '../assets/osprey/dayliteToteSecond.jpg';

import transporter40lFirst from '../assets/osprey/transporter40lFirst.jpg';
import transporter40lSecond from '../assets/osprey/transporter40lSecond.jpg';
import transporter40lThird from '../assets/osprey/transporter40lThird.jpg';

import aetherFirst from '../assets/osprey/aetherFirst.jpg';
import aetherSecond from '../assets/osprey/aetherSecond.jpg';
import aetherThird from '../assets/osprey/aetherThird.jpg';

import raptor10lFirst from '../assets/osprey/raptor10lFirst.jpg';
import raptor10lSecond from '../assets/osprey/raptor10lSecond.jpg';
import raptor10lThird from '../assets/osprey/raptor10lThird.jpg';

/* Petzl */
import petzlBanner from '../assets/petzl/petzlBanner.jpg';
import petzlLogo from '../assets/petzl/petzlLogo.png';

import meteorFirst from '../assets/petzl/meteorFirst.jpg';
import meteorSecond from '../assets/petzl/meteorSecond.jpg';
import meteorThird from '../assets/petzl/meteorThird.jpg';

import picchuFirst from '../assets/petzl/picchuFirst.jpg';
import picchuSecond from '../assets/petzl/picchuSecond.jpg';
import picchuThird from '../assets/petzl/picchuThird.jpg';

import canyonGuideFirst from '../assets/petzl/canyonGuideFirst.jpg';
import canyonGuideSecond from '../assets/petzl/canyonGuideSecond.jpg';
import canyonGuideThird from '../assets/petzl/canyonGuideThird.jpg';

import crevasseRescueFirst from '../assets/petzl/crevasseRescueFirst.jpg';

import sumtecFirst from '../assets/petzl/sumtecFirst.jpg';
import sumtecSecond from '../assets/petzl/sumtecSecond.jpg';

import nao2First from '../assets/petzl/nao2First.jpg';
import nao2Second from '../assets/petzl/nao2Second.jpg';
import nao2Third from '../assets/petzl/nao2Third.jpg';

import dartFirst from '../assets/petzl/dartFirst.jpg';

import siroccoFirst from '../assets/petzl/siroccoFirst.jpg';

import ergonomicIceFirst from '../assets/petzl/ergonomicIceFirst.jpg';
import ergonomicIceSecond from '../assets/petzl/ergonomicIceSecond.jpg';
import ergonomicIceThird from '../assets/petzl/ergonomicIceThird.jpg';

import cordexPlusFirst from '../assets/petzl/cordexPlusFirst.jpg';
import cordexPlusSecond from '../assets/petzl/cordexPlusSecond.jpg';
import cordexPlusThird from '../assets/petzl/cordexPlusThird.jpg';

/* Salewa */
import salewaBanner from '../assets/salewa/salewaBanner.jpg';
import salewaLogo from '../assets/salewa/salewaLogo.png';

import brentaFirst from '../assets/salewa/brentaFirst.jpg';
import brentaSecond from '../assets/salewa/brentaSecond.jpg';
import brentaThird from '../assets/salewa/brentaThird.jpg';

import antelaoFirst from '../assets/salewa/antelaoFirst.jpg';
import antelaoSecond from '../assets/salewa/antelaoSecond.jpg';
import antelaoThird from '../assets/salewa/antelaoThird.jpg';

import sarnerFirst from '../assets/salewa/sarnerFirst.jpg';
import sarnerSecond from '../assets/salewa/sarnerSecond.jpg';

import litetrekFirst from '../assets/salewa/litetrekFirst.jpg';
import litetrekSecond from '../assets/salewa/litetrekSecond.jpg';
import litetrekThird from '../assets/salewa/litetrekThird.jpg';

import micra2First from '../assets/salewa/micra2First.jpg';
import micra2Second from '../assets/salewa/micra2Second.jpg';

import northxFirst from '../assets/salewa/northxFirst.jpg';
import northxSecond from '../assets/salewa/northxSecond.jpg';

import carboniumFirst from '../assets/salewa/carboniumFirst.jpg';
import carboniumSecond from '../assets/salewa/carboniumSecond.jpg';
import carboniumThird from '../assets/salewa/carboniumThird.jpg';

import vayu2First from '../assets/salewa/vayu2First.jpg';
import vayu2Second from '../assets/salewa/vayu2Second.jpg';
import vayu2Third from '../assets/salewa/vayu2Third.jpg';

import mtnSpikeFirst from '../assets/salewa/mtnSpikeFirst.jpg';
import mtnSpikeSecond from '../assets/salewa/mtnSpikeSecond.jpg';
import mtnSpikeThird from '../assets/salewa/mtnSpikeThird.jpg';

import rozesWarmFirst from '../assets/salewa/rozesWarmFirst.jpg';

/* Salomon */
import salomonBanner from '../assets/salomon/salomonBanner.jpg';
import salomonLogo from '../assets/salomon/salomonLogo.png';

import supercross4First from '../assets/salomon/supercross4First.jpg';
import supercross4Second from '../assets/salomon/supercross4Second.jpg';
import supercross4Third from '../assets/salomon/supercross4Third.jpg';

import hypulseFirst from '../assets/salomon/hypulseFirst.jpg';
import hypulseSecond from '../assets/salomon/hypulseSecond.jpg';
import hypulseThird from '../assets/salomon/hypulseThird.jpg';

import alphacrossBlastFirst from '../assets/salomon/alphacrossBlastFirst.jpg';
import alphacrossBlastSecond from '../assets/salomon/alphacrossBlastSecond.jpg';
import alphacrossBlastThird from '../assets/salomon/alphacrossBlastThird.jpg';

import xraiseFirst from '../assets/salomon/xraiseFirst.jpg';
import xraiseSecond from '../assets/salomon/xraiseSecond.jpg';
import xraiseThird from '../assets/salomon/xraiseThird.jpg';

import crosshikeFirst from '../assets/salomon/crosshikeFirst.jpg';
import crosshikeSecond from '../assets/salomon/crosshikeSecond.jpg';
import crosshikeThird from '../assets/salomon/crosshikeThird.jpg';

import quest4First from '../assets/salomon/quest4First.jpg';
import quest4Second from '../assets/salomon/quest4Second.jpg';
import quest4Third from '../assets/salomon/quest4Third.jpg';

import crossrunFirst from '../assets/salomon/crossrunFirst.jpg';
import crossrunSecond from '../assets/salomon/crossrunSecond.jpg';
import crossrunThird from '../assets/salomon/crossrunThird.jpg';

import sensePolesFirst from '../assets/salomon/sensePolesFirst.jpg';
import sensePolesSecond from '../assets/salomon/sensePolesSecond.jpg';
import sensePolesThird from '../assets/salomon/sensePolesThird.jpg';

import xt6lFirst from '../assets/salomon/xt6lFirst.jpg';
import xt6lSecond from '../assets/salomon/xt6lSecond.jpg';
import xt6lThird from '../assets/salomon/xt6lThird.jpg';

import trailLowFirst from '../assets/salomon/trailLowFirst.jpg';
import trailLowSecond from '../assets/salomon/trailLowSecond.jpg';
import trailLowThird from '../assets/salomon/trailLowThird.jpg';

/* Sportiva */
import sportivaBanner from '../assets/sportiva/sportivaBanner.jpg';
import sportivaLogo from '../assets/sportiva/sportivaLogo.png';

import blizzardFirst from '../assets/sportiva/blizzardFirst.jpg';
import blizzardSecond from '../assets/sportiva/blizzardSecond.jpg';
import blizzardThird from '../assets/sportiva/blizzardThird.jpg';

import ultraraptorFirst from '../assets/sportiva/ultraraptorFirst.jpg';
import ultraraptorSecond from '../assets/sportiva/ultraraptorSecond.jpg';
import ultraraptorThird from '../assets/sportiva/ultraraptorThird.jpg';

import jynxFirst from '../assets/sportiva/jynxFirst.jpg';
import jynxSecond from '../assets/sportiva/jynxSecond.jpg';
import jynxThird from '../assets/sportiva/jynxThird.jpg';

import xcursion28lFirst from '../assets/sportiva/xcursion28lFirst.jpg';
import xcursion28lSecond from '../assets/sportiva/xcursion28lSecond.jpg';

import trangopolesFirst from '../assets/sportiva/trangopolesFirst.jpg';
import trangopolesSecond from '../assets/sportiva/trangopolesSecond.jpg';
import trangopolesThird from '../assets/sportiva/trangopolesThird.jpg';

import gripitFirst from '../assets/sportiva/gripitFirst.jpg';
import gripitSecond from '../assets/sportiva/gripitSecond.jpg';
import gripitThird from '../assets/sportiva/gripitThird.jpg';

import mythosFirst from '../assets/sportiva/mythosFirst.jpg';
import mythosSecond from '../assets/sportiva/mythosSecond.jpg';
import mythosThird from '../assets/sportiva/mythosThird.jpg';

import katanaFirst from '../assets/sportiva/katanaFirst.jpg';
import katanaSecond from '../assets/sportiva/katanaSecond.jpg';
import katanaThird from '../assets/sportiva/katanaThird.jpg';

import nepalcubeFirst from '../assets/sportiva/nepalcubeFirst.jpg';
import nepalcubeSecond from '../assets/sportiva/nepalcubeSecond.jpg';
import nepalcubeThird from '../assets/sportiva/nepalcubeThird.jpg';

import trangoicecubeFirst from '../assets/sportiva/trangoicecubeFirst.jpg';
import trangoicecubeSecond from '../assets/sportiva/trangoicecubeSecond.jpg';
import trangoicecubeThird from '../assets/sportiva/trangoicecubeThird.jpg';

/* Summit */
import summitBanner from '../assets/summit/summitBanner.jpg';
import summitLogo from '../assets/summit/summitLogo.png';

import nylonTarpFirst from '../assets/summit/nylonTarpFirst.jpg';
import nylonTarpSecond from '../assets/summit/nylonTarpSecond.jpg';
import nylonTarpThird from '../assets/summit/nylonTarpThird.jpg';

import ultraSilFirst from '../assets/summit/ultraSilFirst.jpg';
import ultraSilSecond from '../assets/summit/ultraSilSecond.jpg';

import grasshopperFirst from '../assets/summit/grasshopperFirst.jpg';
import grasshopperSecond from '../assets/summit/grasshopperSecond.jpg';

import sparkSpivFirst from '../assets/summit/sparkSpivFirst.jpg';
import sparkSpivSecond from '../assets/summit/sparkSpivSecond.jpg';
import sparkSpivThird from '../assets/summit/sparkSpivThird.jpg';

import etherLightFirst from '../assets/summit/etherLightFirst.jpg';
import etherLightSecond from '../assets/summit/etherLightSecond.jpg';
import etherLightThird from '../assets/summit/etherLightThird.jpg';

import aerosDownFirst from '../assets/summit/aerosDownFirst.jpg';
import aerosDownSecond from '../assets/summit/aerosDownSecond.jpg';
import aerosDownThird from '../assets/summit/aerosDownThird.jpg';

import deltalightFirst from '../assets/summit/deltalightFirst.jpg';

import doubleFirst from '../assets/summit/doubleFirst.jpg';
import doubleSecond from '../assets/summit/doubleSecond.jpg';

import jungleFirst from '../assets/summit/jungleFirst.jpg';
import jungleSecond from '../assets/summit/jungleSecond.jpg';
import jungleThird from '../assets/summit/jungleThird.jpg';

import hammockFirst from '../assets/summit/hammockFirst.jpg';
import hammockSecond from '../assets/summit/hammockSecond.jpg';
import hammockThird from '../assets/summit/hammockThird.jpg';

/* Vaude */
import vaudeBanner from '../assets/vaude/vaudeBanner.jpg';
import vaudeLogo from '../assets/vaude/vaudeLogo.png';

import lapitaFirst from '../assets/vaude/lapitaFirst.jpg';
import lapitaSecond from '../assets/vaude/lapitaSecond.jpg';
import lapitaThird from '../assets/vaude/lapitaThird.jpg';

import skomerFirst from '../assets/vaude/skomerFirst.jpg';
import skomerSecond from '../assets/vaude/skomerSecond.jpg';
import skomerThird from '../assets/vaude/skomerThird.jpg';

import casareaFirst from '../assets/vaude/casareaFirst.jpg';
import casareaSecond from '../assets/vaude/casareaSecond.jpg';
import casareaThird from '../assets/vaude/casareaThird.jpg';

import rondaneFirst from '../assets/vaude/rondaneFirst.jpg';
import rondaneSecond from '../assets/vaude/rondaneSecond.jpg';
import rondaneThird from '../assets/vaude/rondaneThird.jpg';

import mwpFirst from '../assets/vaude/mwpFirst.jpg';
import mwpSecond from '../assets/vaude/mwpSecond.jpg';

import zerumFirst from '../assets/vaude/zerumFirst.jpg';
import zerumSecond from '../assets/vaude/zerumSecond.jpg';

import minnieFirst from '../assets/vaude/minnieFirst.jpg';
import minnieSecond from '../assets/vaude/minnieSecond.jpg';

import santisFirst from '../assets/vaude/santisFirst.jpg';
import santisSecond from '../assets/vaude/santisSecond.jpg';

import selunFirst from '../assets/vaude/selunFirst.jpg';
import selunSecond from '../assets/vaude/selunSecond.jpg';
import selunThird from '../assets/vaude/selunThird.jpg';

import taurusFirst from '../assets/vaude/taurusFirst.jpg';
import taurusSecond from '../assets/vaude/taurusSecond.jpg';
import taurusThird from '../assets/vaude/taurusThird.jpg';

/* Creator */
import creator1 from '../assets/creator/creator1.jpg';
import creator2 from '../assets/creator/creator2.jpg';
import creator3 from '../assets/creator/creator3.jpg';
import creator4 from '../assets/creator/creator4.jpg';
import creator5 from '../assets/creator/creator5.jpg';
import creator6 from '../assets/creator/creator6.jpg';
import creator7 from '../assets/creator/creator7.jpg';
import creator8 from '../assets/creator/creator8.jpg';
import creator9 from '../assets/creator/creator9.jpg';
import creator10 from '../assets/creator/creator10.jpg';
import creator11 from '../assets/creator/creator11.jpg';
import creator12 from '../assets/creator/creator12.jpg';
import creator13 from '../assets/creator/creator13.jpg';
import creator14 from '../assets/creator/creator14.jpg';
import creator15 from '../assets/creator/creator15.jpg';
import creator16 from '../assets/creator/creator16.jpg';
import creator17 from '../assets/creator/creator17.jpg';
import creator18 from '../assets/creator/creator18.jpg';
import creator19 from '../assets/creator/creator19.jpg';
import creator20 from '../assets/creator/creator20.jpg';

const images = {
  quote,
  headerBackground,
  discount,
  discountLogo,
  expeditionsCard,
  runningCard,
  hikingCard,
  campingCard,
  climbingCard,
  rain,
  boot,
  weather,
  todo,
  night,
  trail,
  tent,
  benefits,
  cube,
  newsletter,
  hiker,
  delivery,
  spring,
  paypal,
  swipe,
  click,
  maestro,
  mastercard,
  visa,
  americanexpress,
  checked,
  error,
  exclamation,

/* Adidas */
  adidasBanner,
  adidasLogo,

  swiftR2First,
  swiftR2Second,
  swiftR2Third,

  freeHikerFirst,
  freeHikerSecond,
  freeHikerThird,

  hyperHikerFirst,
  hyperHikerSecond,
  hyperHikerThird,

  myShelterFirst,
  myShelterSecond,
  myShelterThird,

  liteFlexFirst,
  liteFlexSecond,
  liteFlexThird,

  techFirst,
  techSecond,
  techThird,

  xploricFirst,
  xploricSecond,
  xploricThird,

  liteflexShortsFirst,
  liteflexShortsSecond,
  liteflexShortsThird,

  agravicFirst,
  agravicSecond,
  agravicThird,

  goretexFirst,
  goretexSecond,
  goretexThird,

/* Columbia */
  columbiaBanner,
  columbiaLogo,

  firecampFleece3First,
  firecampFleece3Second,
  firecampFleece3Third,

  facet60First,
  facet60Second,
  facet60Third,

  redmondYouthFirst,
  redmondYouthSecond,
  redmondYouthThird,

  adventureFirst,
  adventureSecond,
  adventureThird,

  silverRidge4First,
  silverRidge4Second,
  silverRidge4Third,

  bloomingportFirst,
  bloomingportSecond,
  bloomingportThird,

  maxtrailFirst,
  maxtrailSecond,
  maxtrailThird,

  trailSummitRunningFirst,
  trailSummitRunningSecond,
  trailSummitRunningThird,

  columbiaUltraFirst,
  columbiaUltraSecond,
  columbiaUltraThird,

  fct03First,
  fct03Second,
  fct03Third,

/* Diamond */
  diamondBanner,
  diamondLogo,

  cliffCabanaFirst,
  cliffCabanaSecond,
  cliffCabanaThird,

  missionFirst,
  missionSecond,
  missionThird,

  methodFirst,
  methodSecond,
  methodThird,

  shadowLVFirst,
  shadowLVSecond,
  shadowLVThird,

  captainFirst,
  captainSecond,
  captainThird,

  momentumFirst,
  momentumSecond,
  momentumThird,

  speedFirst,
  speedSecond,
  speedThird,

  venomIceFirst,
  venomIceSecond,
  venomIceThird,

  distanceFirst,
  distanceSecond,
  distanceThird,

  wizFirst,

/* Haglofs */
  haglofsBanner,
  haglofsLogo,

  dualityat1First,
  dualityat1Second,
  dualityat1Third,

  nordicExpFirst,
  nordicExpSecond,

  limfhFirst,
  limfhSecond,
  limfhThird,

  vassiProFirst,
  vassiProSecond,
  vassiProThird,

  limlowFirst,
  limlowSecond,
  limlowThird,

  ridgemidFirst,
  ridgemidSecond,
  ridgemidThird,

  vina40lFirst,
  vina40lSecond,
  vina40lThird,

  midSlimFirst,
  midSlimSecond,

  tariusFirst,
  tariusSecond,
  tariusThird,

  astralFullFirst,
  astralFullSecond,
  astralFullThird,

/* Mammut */
  mammutBanner,
  mammutLogo,

  comfortfastFirst,
  comfortfastSecond,

  protectDownFirst,
  protectDownSecond,
  protectDownThird,

  cragsenderFirst,
  cragsenderSecond,
  cragsenderThird,

  rgFirst,
  rgSecond,
  rgThird,

  trion75lFirst,
  trion75lSecond,

  nordwand6000First,
  nordwand6000Second,
  nordwand6000Third,

  mercuryFirst,
  mercurySecond,
  mercuryThird,

  nordwandhighFirst,
  nordwandhighSecond,
  nordwandhighThird,

  sapuenFirst,
  sapuenSecond,
  sapuenThird,

  shortsFirst,
  shortsSecond,
  shortsThird,

/* Merrell */
  merrellBanner,
  merrellLogo,

  moabspeedFirst,
  moabspeedSecond,
  moabspeedThird,

  trailgloveFirst,
  trailgloveSecond,
  trailgloveThird,

  altalightFirst,
  altalightSecond,
  altalightThird,

  oakcreekFirst,
  oakcreekSecond,
  oakcreekThird,

  moabflightFirst,
  moabflightSecond,
  moabflightThird,

  nova2midFirst,
  nova2midSecond,
  nova2midThird,

  interceptFirst,
  interceptSecond,
  interceptThird,

  bravadaFirst,
  bravadaSecond,
  bravadaThird,

  rubatoFirst,
  rubatoSecond,
  rubatoThird,

  sirentravellerFirst,
  sirentravellerSecond,
  sirentravellerThird,

/* North */
  northBanner,
  northLogo,

  ultraEnduranceFirst,
  ultraEnduranceSecond,
  ultraEnduranceThird,

  youthChilkFirst,
  youthChilkSecond,
  youthChilkThird,

  resolveFirst,
  resolveSecond,
  resolveThird,

  grivolaFirst,
  grivolaSecond,
  grivolaThird,

  thermoballFirst,
  thermoballSecond,
  thermoballThird,

  resolveFullFirst,
  resolveFullSecond,
  resolveFullThird,

  motionFirst,
  motionSecond,
  motionThird,

  fornetFirst,
  fornetSecond,
  fornetThird,

  resolveReflectiveFirst,
  resolveReflectiveSecond,

  chakalFirst,
  chakalSecond,

/* Osprey */
  ospreyBanner,
  ospreyLogo,

  zealotchalkFirst,
  zealotchalkSecond,
  zealotchalkThird,

  zealot1lFirst,
  zealot1lSecond,
  zealot1lThird,

  triplesnapFirst,

  arielPlusFirst,
  arielPlusSecond,
  arielPlusThird,

  archeonFirst,
  archeonSecond,
  archeonThird,

  dayliteSlingFirst,
  dayliteSlingSecond,
  dayliteSlingThird,

  dayliteToteFirst,
  dayliteToteSecond,

  transporter40lFirst,
  transporter40lSecond,
  transporter40lThird,

  aetherFirst,
  aetherSecond,
  aetherThird,

  raptor10lFirst,
  raptor10lSecond,
  raptor10lThird,

/* Petzl */
  petzlBanner,
  petzlLogo,

  meteorFirst,
  meteorSecond,
  meteorThird,

  picchuFirst,
  picchuSecond,
  picchuThird,

  canyonGuideFirst,
  canyonGuideSecond,
  canyonGuideThird,

  crevasseRescueFirst,

  sumtecFirst,
  sumtecSecond,

  nao2First,
  nao2Second,
  nao2Third,

  siroccoFirst,

  dartFirst,

  ergonomicIceFirst,
  ergonomicIceSecond,
  ergonomicIceThird,

  cordexPlusFirst,
  cordexPlusSecond,
  cordexPlusThird,

/* Salewa */
  salewaBanner,
  salewaLogo,

  brentaFirst,
  brentaSecond,
  brentaThird,

  antelaoFirst,
  antelaoSecond,
  antelaoThird,

  sarnerFirst,
  sarnerSecond,

  litetrekFirst,
  litetrekSecond,
  litetrekThird,

  micra2First,
  micra2Second,

  northxFirst,
  northxSecond,

  carboniumFirst,
  carboniumSecond,
  carboniumThird,

  vayu2First,
  vayu2Second,
  vayu2Third,

  mtnSpikeFirst,
  mtnSpikeSecond,
  mtnSpikeThird,

  rozesWarmFirst,

/* Salomon */
  salomonBanner,
  salomonLogo,

  supercross4First,
  supercross4Second,
  supercross4Third,

  hypulseFirst,
  hypulseSecond,
  hypulseThird,

  alphacrossBlastFirst,
  alphacrossBlastSecond,
  alphacrossBlastThird,

  xraiseFirst,
  xraiseSecond,
  xraiseThird,

  crosshikeFirst,
  crosshikeSecond,
  crosshikeThird,

  quest4First,
  quest4Second,
  quest4Third,

  crossrunFirst,
  crossrunSecond,
  crossrunThird,

  sensePolesFirst,
  sensePolesSecond,
  sensePolesThird,

  xt6lFirst,
  xt6lSecond,
  xt6lThird,

  trailLowFirst,
  trailLowSecond,
  trailLowThird,

/* Sportiva */
  sportivaBanner,
  sportivaLogo,

  blizzardFirst,
  blizzardSecond,
  blizzardThird,

  ultraraptorFirst,
  ultraraptorSecond,
  ultraraptorThird,

  jynxFirst,
  jynxSecond,
  jynxThird,

  xcursion28lFirst,
  xcursion28lSecond,

  trangopolesFirst,
  trangopolesSecond,
  trangopolesThird,

  gripitFirst,
  gripitSecond,
  gripitThird,

  mythosFirst,
  mythosSecond,
  mythosThird,

  katanaFirst,
  katanaSecond,
  katanaThird,

  nepalcubeFirst,
  nepalcubeSecond,
  nepalcubeThird,

  trangoicecubeFirst,
  trangoicecubeSecond,
  trangoicecubeThird,

/* Summit */
  summitBanner,
  summitLogo,

  nylonTarpFirst,
  nylonTarpSecond,
  nylonTarpThird,

  ultraSilFirst,
  ultraSilSecond,

  grasshopperFirst,
  grasshopperSecond,

  sparkSpivFirst,
  sparkSpivSecond,
  sparkSpivThird,

  etherLightFirst,
  etherLightSecond,
  etherLightThird,

  aerosDownFirst,
  aerosDownSecond,
  aerosDownThird,

  deltalightFirst,

  doubleFirst,
  doubleSecond,

  jungleFirst,
  jungleSecond,
  jungleThird,

  hammockFirst,
  hammockSecond,
  hammockThird,

  /* Vaude */
  vaudeBanner,
  vaudeLogo,

  lapitaFirst,
  lapitaSecond,
  lapitaThird,

  skomerFirst,
  skomerSecond,
  skomerThird,

  casareaFirst,
  casareaSecond,
  casareaThird,

  rondaneFirst,
  rondaneSecond,
  rondaneThird,

  mwpFirst,
  mwpSecond,

  zerumFirst,
  zerumSecond,

  minnieFirst,
  minnieSecond,

  santisFirst,
  santisSecond,

  selunFirst,
  selunSecond,
  selunThird,

  taurusFirst,
  taurusSecond,
  taurusThird,

/* Creator */
  creator1,
  creator2,
  creator3,
  creator4,
  creator5,
  creator6,
  creator7,
  creator8,
  creator9,
  creator10,
  creator11,
  creator12,
  creator13,
  creator14,
  creator15,
  creator16,
  creator17,
  creator18,
  creator19,
  creator20,
};

export default images;
